module.exports = __webpack_public_path__ + "static/media/youtube.1c7d261f.svg";